import {Injectable} from '@angular/core';
import {SharedService} from 'src/app/shared';
import {Menu, MENU_ITEM_TYPE} from './side-nav-bar.model';
import {AppConfig} from '../../app.config';
import {ROLES} from '../../shared/constants/common.constants';


@Injectable()
export class SideNavBarService {

  MENU_ITEMS: Menu[] = [
    {
      state: AppConfig._ADMIN_CUSTOMER,
      name: 'Customer Management',
      type: MENU_ITEM_TYPE.LINK,
      visibility: this.checkAdmin(),
      icon: 'person'
    },
    {
      state: AppConfig._CUSTOMER_DASHBOARD,
      name: 'Dashboard',
      type: MENU_ITEM_TYPE.LINK,
      visibility: this.checkCustomer(),
      icon: 'person'
    },
    {
      state: AppConfig._ADMIN_DEVICE_FIRMWARE,
      name: 'Device Firmware',
      type: MENU_ITEM_TYPE.LINK,
      visibility: true,
      icon: 'system_update'
    },
    {
      state: AppConfig._ADMIN_DEVICE_LOGS,
      name: 'Device Logs',
      type: MENU_ITEM_TYPE.LINK,
      visibility: this.checkAdmin(),
      icon: 'book'
    }
  ];

  constructor(private sharedService: SharedService) {
  }

  getAll(): Menu[] {
    return this.MENU_ITEMS;
  }

  checkAdmin() {
    return this.sharedService.getRole().includes(ROLES.ADMIN);
  }

  checkCustomer() {
    return this.sharedService.getRole().includes(ROLES.CUSTOMER);
  }

}
